module.exports = __webpack_public_path__ + "static/media/bike-busy.c042cbfb.svg";